import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  CONFIGURATION_SELECT,
  CONFIGURATION_DESELECT,
  CONFIGURATION_CREATE_START,
  CONFIGURATION_CREATE_STOP,
  UNLOAD,
} from './types';
import {
  CREATE_CONFIGURATION_SUCCESS,
  REMOVE_CONFIGURATION_SUCCESS,
} from '../types';

const selectedConfigurationId = createReducer(null, {
  [UNLOAD]: () => null,
  [CONFIGURATION_SELECT]: (_, { payload }) => payload.id,
  [CREATE_CONFIGURATION_SUCCESS]: (_, { payload }) =>
    payload.newConfiguration.id,
  [CONFIGURATION_DESELECT]: () => null,
  [CONFIGURATION_CREATE_START]: () => null,
  [REMOVE_CONFIGURATION_SUCCESS]: () => null,
});

const isCreatingNew = createReducer(false, {
  [UNLOAD]: () => false,
  [CONFIGURATION_SELECT]: () => false,
  [CONFIGURATION_DESELECT]: () => false,
  [CONFIGURATION_CREATE_START]: () => true,
  [CONFIGURATION_CREATE_STOP]: () => false,
  [CREATE_CONFIGURATION_SUCCESS]: () => false,
});

export default combineReducers({
  selectedConfigurationId,
  isCreatingNew,
});
